import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'

const CompareCard = ({ fundItem, index, handleCancel, extraClasses, ...restProps }) => {
  const onClick = (id) => {
    handleCancel(id)
  }
  const colorMap = ['blue-card', 'orange-card', 'yellow-card', 'green-card', 'teal-card']
  return (
    <div className={`compare-card" ${extraClasses}`} {...restProps}>
      <div className={`compare-card-color ${colorMap[index]}`} />
      <div className="compare-card-button">
        <fil-icon icon="close" size="12" color="grey-800" onClick={() => onClick(fundItem)} />
      </div>
      <div className="compare-card__label">{fundItem.shareClassName}</div>
    </div>
  )
}

CompareCard.propTypes = {
  fundItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  handleCancel: PropTypes.func.isRequired,
  extraClasses: PropTypes.string
}

CompareCard.defaultProps = {
  extraClasses: ''
}

export default CompareCard
